import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from '@services/core/auth.service';

@Component({
  selector: 'registration-complete',
  templateUrl: './registration-complete.component.html',
  styleUrls: ['./registration-complete.component.scss']
})
export class RegistrationCompleteComponent implements OnInit {
  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<RegistrationCompleteComponent>,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: {}
  ) {}

  ngOnInit(): void {}

  async navigateToAdminPanel() {
    this.dialogRef.close();
    await this.authService.loadPermissions().then(t => {
      return this.router.navigateByUrl('/company');
    });
  }

  async navigateToHomePage() {
    this.dialogRef.close();
    await this.authService.loadPermissions().then(t => {
      return this.router.navigateByUrl('/dashboard');
    });
  }
}
